import {Component, OnInit} from '@angular/core';
import {AuthService} from "./data/services/modules/auth/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PrimeNGConfig} from "primeng/api";
import {PushingService} from "./data/services/api/flow/pushing.service";
import {LoaderService} from "./modules/private/verify-information/data/services/page/loader.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'pulpi-v4-app';
  showLeftMenu = false

  constructor(
    public authService: AuthService,
    public loaderService: LoaderService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private config: PrimeNGConfig,
    private pushingService: PushingService
  ) {
    this.config.setTranslation({
      startsWith: 'Empieza con',
      contains: 'Contiene',
      notContains: 'No contiene',
      endsWith: 'Acaba en',
      equals: 'Igual',
      notEquals: 'No igual',
      noFilter: 'Sin filtro',
      lt: 'Menor que',
      matchAll: 'Coincide con todos',
      matchAny: 'Coincide con cualquiera',
      dateIs: 'La fecha es',
      dateIsNot: 'La fecha no es',
      dateAfter: 'La fecha es despues de',
      dateBefore: 'La fecha es antes de',
      addRule: 'Agregar regla',
      clear: 'Limpiar',
      apply: 'Aplicar',
      gt: 'Mayor que',
      gte: 'Mayor o igual que',
      lte: 'Menor o igual que',
      weak: 'Debil',
      medium: 'Aceptable',
      strong: 'Fuerte',
      passwordPrompt: 'Ingresa una contraseña'
    })
  }
}
